import chroma from 'chroma-js';
import HelpTooltip from '@/app/common/components/HelpTooltip';
import { decodeGetter } from '@/app/common/components/ag-grid/configs';
import { getColor } from '@/helpers/utils';
import { FaDesktop, FaMobileScreenButton } from 'react-icons/fa6';
import numberHumanizer from '@/helpers/numberHumanizer';
import timeStampToDate from '@/helpers/timeStampToDate';

import { commonTooltips } from '@/app/common/tooltip/commonTooltips';
export const ranksHistoricalColumnConfig = (columns, isMdUp) => {
  const greenColors = chroma
    .scale([
      chroma(getColor('success')).brighten(1),
      chroma(getColor('success')).darken(1)
    ])
    .mode('lab')
    .colors(51)
    .reverse();

  const redColors = chroma
    .scale([
      chroma(getColor('danger')).brighten(1),
      chroma(getColor('danger')).darken(1)
    ])
    .mode('lab')
    .colors(51)
    .reverse();

  let mapCoumns = [
    {
      field: 'keyword',
      type: 'string',
      title: 'کلمه کلیدی',
      minWidth: 130,
      width: isMdUp ? 280 : 220,
      pinned: isMdUp && 'right',
      searchable: true,
      filterValueGetter: decodeGetter,
      cellRenderer: params => {
        let keywordDecoded;
        try {
          keywordDecoded = decodeURIComponent(params.value);
        } catch (err) {
          keywordDecoded = params.value;
        }
        return (
          <>
            {keywordDecoded}
            {params.data.device_type === 1 ? (
              <FaDesktop className="mx-1" title="mobile" />
            ) : (
              <FaMobileScreenButton className="mx-1" title="mobile" />
            )}
            <span className="border border-1 fs--2 rounded-2 py-0 px-1">
              {params?.data?.location}
            </span>
          </>
        );
      }
    },
    {
      field: 'search_volume_miztols',
      type: 'number',
      title: 'میزان جستجو',
      width: 125,
      searchable: true,
      // pinned: 'right',
      cellRenderer: params => {
        return (
          <>
            {!params.value ? (
              <HelpTooltip html={commonTooltips.searchVolume} />
            ) : (
              numberHumanizer(params.value)
            )}
          </>
        );
      }
    }
  ];

  columns?.map(item => {
    mapCoumns.push({
      field: item,
      type: 'string',
      suppressHeaderMenuButton: true,
      sortable: false,
      flex: 1,
      minWidth: 200,
      cellStyle: params => {
        return {
          backgroundColor: params.value
            ? params.value != 999 && params.value <800
              ? params.value <= 50
                ? greenColors[params.value]
                : redColors[100 - params.value]
              : redColors[0]
            : null,
          color: params.value
            ? params.value != 999
              ? params.value <= 50
                ? '#111'
                : '#111'
              : '#111'
            : null,
          fontWeight: 800
        };
      },
      title: timeStampToDate(Number(item)).slice(8).toPersianDigit(),
      searchable: true,
      cellRenderer: params =>
        params.value === 999 ? (
          <span>بدون رتبه</span>
        ) : params.value>=800 && params.value<890 ? (
          <span>&lt; {(parseInt(params.value, 10) % 800) + 10}</span>
        ) : (
          <span>{params.value}</span>
        )
    });
  });
  return mapCoumns;
};

export const competitorsColumnForFilterConfig = () => {
  let mapCoumns = [
    {
      field: 'title',
      type: 'string',
      title: 'کلمه کلیدی',
      width: 300,
      pinned: 'right',
      searchable: true
    },
    {
      field: 'search_volume_miztols',
      type: 'number',
      title: 'میزان جستجو',
      width: 142,
      searchable: false
    },
    {
      field: 'device_type',
      type: 'select',
      title: 'نوع دستگاه',
      width: 120,
      searchable: true
    },
    {
      field: 'location',
      type: 'select',
      title: 'مکان جستجو',
      width: 120,
      searchable: true
    }
  ];
  return mapCoumns;
};
